import React, { useState } from 'react'
import { IconSettings } from "@tabler/icons-react"
import { GetRequest } from "../../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import useLocalStorageState from 'use-local-storage-state';
import { ReportOffcanvas } from './ReportOffcanvas';
import { formatDate, putCommaInLeadsValue } from '../../../Utils/helpers/commonhelper';
import { generateModuleSchema } from '../Report';

const generateTableData = (filterName, data) => {
    const normalizedFilter = filterName?.toLowerCase().replace(/\s+/g, '_');

    let leadsData = []
    let dealsData = []
    let contactData = []
    let companyData = []
    let quotationData = []
    let purchaseData = []
    let salesData = []

    if (normalizedFilter === "leads") {
        leadsData = data?.map((item) => {
            const productsArr = JSON.parse(item.product_services) || []
            const totalBudget =
                (Array.isArray(productsArr) &&
                    productsArr?.reduce(
                        (acc, curr) => acc + (parseFloat(curr?.budget) || 0),
                        0
                    )) ||
                0
            return {
                name: item.contact_full_name || "-",
                lead_id: item.lead_no,
                phone: (item.user_phone && JSON.parse(item.user_phone)[0].phone) || "-",
                email: item.email?.toLowerCase() || "-",
                budget: putCommaInLeadsValue(totalBudget) || "-",
                requirement: item.requirement || "-",
                service: item.service || "-",
                source: item.source_title || "-",
                expected_closure_date: formatDate(item.expected_closure_date) || "-",
                lead_status: item.lead_status || "-",
            }
        })
        return leadsData
    } else if (normalizedFilter === "deals") {
        dealsData = data?.map((item) => {
            const productsArr = JSON.parse(item.product_services) || []
            const totalBudget =
                (Array.isArray(productsArr) &&
                    productsArr?.reduce(
                        (acc, curr) => acc + (parseFloat(curr?.budget) || 0),
                        0
                    )) ||
                0
            return {
                name: item.contact_full_name || "-",
                phone: (item.user_phone && JSON.parse(item.user_phone)[0].phone) || "-",
                email: item.email || "-",
                budget: putCommaInLeadsValue(totalBudget) || "-",
                requirement: item.requirement || "-",
                service: item.service || "-",
                source: item.source_title || "-",
            }
        })
        return dealsData
    } else if (normalizedFilter === "contact") {
        contactData = data?.map((item) => ({
            name: item.contact_full_name || "-",
            email: item.email || "-",
            contact: item.contact_no || "-",
            owner: item.owner_name || "-",
            report_to: item.report_to || "-",
            company_name: item.company_name || "-",
            designation: item.designation || "-",
            department: item.department || "-",
            decision_maker: item.decision_maker || "-",
            city: item.city_name || "-",
            state: item.state_name || "-",
            country: item.nicename || "-",
            zipcode: item.zipcode || "-",
            lead_source: item.source_title || "-",
            tags: (item.tags && JSON.parse(item.tags).forEach((i) => i)) || "-",
            notes: item.note || "-",
        }))
        return contactData
    } else if (normalizedFilter === "company") {
        companyData = data?.map((item) => ({
            name: item.company_name || "-",
            website: item.website || "-",
            industry: item.industry || "-",
            business_type: item.business_type || "-",
            owner: item.owner_name || "-",
            email: item.email || "-",
            address: item.address || "-",
            state: item.state_name || "-",
            city: item.city_name || "-",
            zipcode: item.zipcode || "-",
        }))
        return companyData
    } else if (normalizedFilter === "quotation") {
        quotationData = data?.map((item) => {
            return {
                quotation_number: item.quotation_number || "-",
                contact: item.contact_full_name || "-",
                contact_no:
                    (item.user_phone && JSON.parse(item.user_phone)[0].phone) || "-",
                company: item.company || "-",
                quotation_date: item.quotation_date || "-",
                expiry_date: item.expiry_date || "-",
                lead_owner: item.lead_owner || "-",
                deal: item.deal || "-",
                quotation_status: item.quotation_status || "-",
            }
        })
        return quotationData
    } else if (normalizedFilter === "purchase_order") {
        purchaseData = data?.map((item) => ({
            po_no: item.po_number || "-",
            po_to: item.contact_full_name || "-",
            company_name: item.company_name || "-",
            po_generated_by: item.owner_name || "-",
            issued_date: formatDate(item.po_date) || "-",
            status: item.status || "-",
        }))
        return purchaseData
    } else if (normalizedFilter === "sales_order") {
        salesData = data?.map((item) => {
            const productsArr = JSON.parse(item.items) || []
            const totalBudget =
                (Array.isArray(productsArr) &&
                    productsArr?.reduce(
                        (acc, curr) => acc + (parseFloat(curr?.amount) || 0),
                        0
                    )) ||
                0

            return {
                date: item.date || "-",
                sales_order: item.sale_no || "-",
                reference: item.reference || "-",
                customer_name: item.contact_full_name || "-",
                status: item.status || "-",
                invoiced: item.invoiced || "-",
                payment: item.payment || "-",
                amount: totalBudget || "-",
                expected_shipment_date: formatDate(item.shipment_date) || "-",
                order_status: item.order_status || "Delivered",
                delivery_method: item.delivery_method || "By Road",
            }
        })
        return salesData
    }

    return []
}
// report card commo
export const ReportCard = ({
    icon,
    title,
    description,
    module_name,
    duration,
    setTableData,
    setTableTitle,
    setSelectedModule,
    tableRef,
    canView
}) => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const headers = {
        authentication: rf,
        Authorization: token,
    }
    const extras = { customer, setCustomer, rf, navigate }
    const customerId = customer?.customer_details?.customer_id
    const [showReportCanvas, setShowReportCanvas] = useState(false)
    const schemaFields = generateModuleSchema(module_name.split(" ").join("_"))
    const mutatedFields = schemaFields.filter((c) => c.label_name !== "date-type")
    const permission = customer.customer_details?.permission;
    const user_type = Number(customer.customer_details?.user_type)
    const reportPermission = permission?.filter(c => c.module_name === "reports")
    // Memoize the fetchData function to prevent unnecessary recreations
    const fetchData = React.useCallback(async () => {
        // common version of checking permission with respect to each module. If no view is give then will not allow them to see the table data
        const isView = user_type !== 1 ? Boolean(Number(reportPermission.filter(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === module_name?.toLowerCase()?.split(" ")?.join("_"))[0]?.view)) : true
        if (!isView) {
            toast.warning(`You are not authorized to view ${module_name} listing!`)
            return
        }
        try {
            let str = `duration=${duration !== null ? duration : ""}&`

            // Build query string
            if (duration === null) return
            schemaFields?.forEach((c, index) => {
                if (
                    c.label_name.toLowerCase() !== "date" &&
                    c.label_name.toLowerCase() !== "search" &&
                    c.label_name.toLowerCase() !== "is_followup"
                ) {
                    str += `${c.label_name}=${""}`
                    if (index < schemaFields.length - 1) {
                        str += "&"
                    }
                }
            })

            const queryString = str
            const res = await GetRequest(
                `report/fetchReportSBasedOnDurationAndModule/${customerId}/${module_name
                    .toLowerCase()
                    .split(" ")
                    .join("_")}?${queryString}`,
                { headers },
                extras
            )

            if (res.success === false || res.status === "fail") {
                toast.error(res.message)
                return
            }
            toast.success(res.message)
            // generating the table data and its corresponding headers and setting the table data
            const tabledata = generateTableData(module_name, res.data)
            setTableData(tabledata)
            setSelectedModule(module_name)
            // tabledata.length > 0 ? setTableTitle(title) : setTableTitle("")
            setTableTitle(title)
            // Scroll to table after data is set
            setTimeout(() => {
                tableRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
            }, 100)
        } catch (error) {
            console.error("Error fetching report data:", error)
            return
        }
    }, [
        customerId,
        module_name,
        duration,
        schemaFields,
        headers,
        extras,
        setTableData,
        setTableTitle,
        setSelectedModule,
        tableRef,
    ])

    return (
        <div className="report-card">
            <div className="card-content" onClick={fetchData}>
                <div className="card-icon">{icon}</div>
                <div className="card-text">
                    <h3 className="card-title">{title}</h3>
                    <p className="card-description">{description}</p>
                </div>
            </div>
            <div className="card-settings" onClick={() => setShowReportCanvas(true)}>
                <IconSettings stroke={2} color="#7a3a5e" />
            </div>
            {showReportCanvas && (
                <ReportOffcanvas
                    show={showReportCanvas}
                    onHide={() => setShowReportCanvas(false)}
                    module_name={module_name.split(" ").join("_")}
                    schemaFields={mutatedFields || []}
                    duration={duration}
                    tableRef={tableRef}
                    setTableData={setTableData}
                    generateTableData={generateTableData}
                />
            )}
        </div>
    )
}